export const clusterJewelEnchantments: { baseType: string; enchantments: string[] }[] = [
];
